var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { TelemetryClient } from "../../TelemetryClient.mjs";
import { CoreReportType } from "./types.mjs";
class CoreTelemetryClient extends TelemetryClient {
  constructor(options) {
    super();
    __publicField(this, "reported", /* @__PURE__ */ new Set());
    this.updateMeta(options);
  }
  report(reportData, options) {
    if ((options == null ? void 0 : options.once) && reportData.type && reportData.name) {
      let hash;
      if (typeof options.once === "function") {
        hash = options.once();
      } else {
        hash = reportData.type + reportData.name;
      }
      if (this.reported.has(hash)) {
        return;
      }
      this.reported.add(hash);
    }
    super.report(reportData, options);
  }
  /**
   * Fills out payload arrays with default values according to the given lengths
   * */
  fillPayload(reportData, payloadLength, numberPayloadLength) {
    if (!reportData.payload) {
      reportData.payload = [];
    }
    if (!reportData.numberPayload) {
      reportData.numberPayload = [];
    }
    if (reportData.payload.length < payloadLength) {
      reportData.payload = reportData.payload.concat(Array(payloadLength - reportData.payload.length).fill(""));
    }
    if (reportData.numberPayload.length < numberPayloadLength) {
      reportData.numberPayload = reportData.numberPayload.concat(
        Array(numberPayloadLength - reportData.numberPayload.length).fill(0)
      );
    }
  }
  reportEvent(reportData, options) {
    this.fillPayload(reportData, 1, 1);
    this.report(Object.assign({ type: CoreReportType.Event }, reportData), options);
  }
  reportFailure(reportData, options) {
    this.fillPayload(reportData, 2, 1);
    this.report(Object.assign({ type: CoreReportType.Failure }, reportData), options);
  }
  reportDuration(reportData, options) {
    this.fillPayload(reportData, 1, 2);
    this.report(Object.assign({ type: CoreReportType.Duration }, reportData), options);
  }
  reportSearch(reportData, options) {
    this.fillPayload(reportData, 2, 0);
    this.report(Object.assign({ type: CoreReportType.Search }, reportData), options);
  }
  reportTranslation(reportData, options) {
    this.fillPayload(reportData, 1, 0);
    this.report(Object.assign({ type: CoreReportType.Translation }, reportData), options);
  }
}
export {
  CoreTelemetryClient
};
